import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store';
import App from './App';

// new plugins
import "bootstrap/dist/css/bootstrap.min.css";
import 'font-awesome/css/font-awesome.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// JS & CSS ( Custome CSS + JS )
import "../src/assets/css/style.css";
import "./assets/css/responsive.css";
import { MovableProvider } from "./context/MovableContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <MovableProvider>
      <App />
      </MovableProvider>
    </Provider>
  </React.StrictMode>
);
